export { VpTeleprompterOverlay } from './VpTeleprompterOverlay';



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpTeleprompterOverlay/index.js